import { render, staticRenderFns } from "./VarsEditor.vue?vue&type=template&id=d9784588&"
import script from "./VarsEditor.vue?vue&type=script&lang=js&"
export * from "./VarsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports